const KYC_POLLING_INTERVAL = 20000; // 20 seconds
const KYC_POLLING_MAX_DURATION = 300000; // 5 minutes
const baseBackendUrl = 'https://backend.anothertomorrow.co';
const baseShopifyBackendUrl = 'https://shopify-app.anothertomorrow.co';
let productId;

exec();

async function exec() {

  let params = new URLSearchParams(window.location.search)

  let idParam = false;
  if(params && params.has('id')) {
    idParam = params.get('id');
  }

  console.log('Current ID param:', idParam);

  if(idParam) {

    // Use the new route that handles token fetching and Aura API call
    const REQUEST_URL = `${baseBackendUrl}/dpp/token-data/${idParam}?includeMetadataHistory=true`;

    console.log('Fetching data from:', 'token');
    const response = await fetch(REQUEST_URL, {
      method: 'GET',
      headers: {
      }
    });

    let apiData;

    if (!response.ok) {
      console.error('API request failed:', response.status, response.statusText);
      return;
    }

    const responseData = await response.json();
    apiData = responseData; // Extract data from the response wrapper
    console.log('API Response:', apiData);

    // Extract status and product ID
    const currentOnchainStatus = apiData.currentOnchainStatus;
    console.log('Product Status:', currentOnchainStatus, 'Product ID:', productId);

    // Parse the attributes JSON string
    const attributes = JSON.parse(apiData.attributes);
    console.log('Parsed Attributes:', attributes);

    // Handle Claim Button State based on Status
    handleClaimButtonState(currentOnchainStatus, productId, idParam);

    // 🆕 Check for Veriff callback
    const isVerifiedCallback = params.get('verified') === 'true';

    if (isVerifiedCallback && currentOnchainStatus === 'CREATED') {
      console.log('[AT-KYC] ↩️ Returned from Veriff with verified=true');

      // Slight delay to ensure UI is ready
      setTimeout(async () => {
        const customer = getCurrentCustomer();
        if (customer && customer.id) {
          // Verify status on backend specifically
          try {
            const profile = await getUserProfile(customer.id);

            if (profile && profile.isVerified === true) {
              console.log('[AT-KYC] ✅ Auto-triggering claim ownership');
              window.ATPopup.showSuccess('Verification successful! Claiming ownership...');
              await claimOwnership();
              // Close success popup after a moment if claim succeeds (claimOwnership handles its own UI usually)
              setTimeout(() => window.ATPopup.close(), 2000);
            } else {
              console.log('[AT-KYC] ⚠️ Returned from Veriff but user not verified yet on backend');
              window.ATPopup.showError('Verification not yet completed on server. Please try clicking "Register" again.');
            }
          } catch (e) {
            console.error('[AT-KYC] Error checking profile on callback:', e);
          }
        }
      }, 1000);
    }

    // Set up resell button if it exists
    const resellButton = document.querySelector('.cProd__buttons .resell');
    if(resellButton) {
      resellButton.setAttribute('href', '/pages/resell-submission?id='+idParam);
    }

    try {

      // Get data from Shopify using the SKU from attributes
      if(attributes.product?.sku) {

        fetch(`${baseShopifyBackendUrl}/api/product-info?sku=${attributes.product.sku}`, {
          method: 'GET',
          headers: {
          }
        })
            .then(response => response.json())
            .then(info => {
              const shopifyData = JSON.parse(info.body)

              productId = String(shopifyData.productId);
              console.log("SAVE PRODUCT " + productId)

              if(shopifyData.image) {
                const imageElement = document.querySelector('.cProd__image-holder img');
                if(imageElement) {
                  imageElement.setAttribute('src', shopifyData.image);
                }
              }

              if(shopifyData.description) {
                const descElement = document.querySelector('.cProd__info-descr');
                if(descElement) {
                  descElement.innerHTML = shopifyData.description;
                }
              }

              if(shopifyData.title) {
                const titleElement = document.querySelector('.cProd__info-title');
                if(titleElement) {
                  titleElement.innerHTML = shopifyData.title;
                }
              }

              if(shopifyData.url) {
                const repurchaseButton = document.querySelector('.cProd__buttons .repurchase');
                if(repurchaseButton) {
                  repurchaseButton.setAttribute('href', shopifyData.url);
                }
              }
            })
            .catch(error => {
              console.error('Error fetching product info:', error);
            });

      }

      // Render primary article sections from Aura data
      if(attributes.primaryArticle && attributes.primaryArticle.copySection4A) {
        renderArticles(attributes.primaryArticle.copySection4A)
      }

      if(attributes.primaryArticle && attributes.primaryArticle.copySection4B) {
        renderArticles(attributes.primaryArticle.copySection4B)
      }

      if(attributes.primaryArticle && attributes.primaryArticle.copySection4C) {
        renderArticles(attributes.primaryArticle.copySection4C)
      }

      if(attributes.primaryArticle && attributes.primaryArticle.copySection4D) {
        renderArticles(attributes.primaryArticle.copySection4D)
      }

      if(attributes.primaryArticle && attributes.primaryArticle.copySection4E) {
        renderArticles(attributes.primaryArticle.copySection4E)
      }

      // Render factory sections from Aura data
      if(attributes.factory && attributes.factory.copySection4F) {
        renderArticles(attributes.factory.copySection4F)
      }

      if(attributes.factory && attributes.factory.copySection4G) {
        renderArticles(attributes.factory.copySection4G)
      }

      // Render who made section
      if(attributes.factory && (attributes.factory.whoMade || attributes.factory.wimStat1)) {
        const whoMadeElement = document.getElementById('who-made');
        if(whoMadeElement) {
          whoMadeElement.replaceChildren();
          if(attributes.factory.whoMade) {
            const p = document.createElement('p');
            p.textContent = attributes.factory.whoMade;
            whoMadeElement.appendChild(p);
          }
          if(attributes.factory.wimStat1) {
            const p = document.createElement('p');
            p.textContent = attributes.factory.wimStat1;
            whoMadeElement.appendChild(p);
          }
        }
      }

      // Render animal welfare section
      if(attributes.primaryArticle && (attributes.primaryArticle.welfareAnimal || attributes.primaryArticle.wimStat2)) {
        const animalElement = document.getElementById('animal');
        if(animalElement) {
          animalElement.replaceChildren();
          if(attributes.primaryArticle.welfareAnimal) {
            const p = document.createElement('p');
            p.textContent = attributes.primaryArticle.welfareAnimal;
            animalElement.appendChild(p);
          }
          if(attributes.primaryArticle.wimStat2) {
            const p = document.createElement('p');
            p.textContent = attributes.primaryArticle.wimStat2;
            animalElement.appendChild(p);
          }
        }
      }

      // Render environmental welfare section
      if(attributes.primaryArticle && (attributes.primaryArticle.wimStat3 || attributes.primaryArticle.welfareEnvironmental)) {
        const environmElement = document.getElementById('environm');
        if(environmElement) {
          environmElement.replaceChildren();
          if(attributes.primaryArticle.welfareEnvironmental) {
            const p = document.createElement('p');
            p.textContent = attributes.primaryArticle.welfareEnvironmental;
            environmElement.appendChild(p);
          }
          if(attributes.primaryArticle.wimStat3) {
            const p = document.createElement('p');
            p.textContent = attributes.primaryArticle.wimStat3;
            environmElement.appendChild(p);
          }
        }
      }

      // Add title and description from the main response if not available from Shopify
      const titleElement = document.querySelector('.cProd__info-title');
      if(apiData.title && titleElement && !titleElement.innerHTML) {
        titleElement.innerHTML = apiData.title;
      }

      const descElement = document.querySelector('.cProd__info-descr');
      if(apiData.description && descElement && !descElement.innerHTML) {
        descElement.innerHTML = apiData.description;
      }

      // Show main content immediately - don't wait for map
      const spinnerElement = document.querySelector('.loading-overlay__spinner');
      if(spinnerElement) {
        spinnerElement.classList.add('hidden');
      }
      const cProdElement = document.querySelector('.cProd');
      if(cProdElement) {
        cProdElement.style.display = 'block';
      }

      // Start map rendering in background (async)
      renderMapAsync(attributes);



    } catch (err) {

      console.log('error'); // output to netlify function log
      console.log(err); // output to netlify function log

    }

  } else {

    const spinnerElement = document.querySelector('.loading-overlay__spinner');
    if(spinnerElement) {
      spinnerElement.classList.add('hidden');
    }

    const cProdElement = document.querySelector('.cProd');
    if(cProdElement) {
      cProdElement.style.display = 'block';
    }
  }

}

function renderArticles(data) {
  const provenItemValues = document.querySelectorAll('.cProd__proven-item-value');
  let num = provenItemValues.length + 1;

  const provenanceDiv = document.querySelector('#provenance > div');
  if(provenanceDiv) {
    const newItem = document.createElement('div');
    newItem.className = 'cProd__proven-item';
    newItem.innerHTML = `
      <div class="cProd__proven-item-number">${num}</div>
      <div class="cProd__proven-item-value">${data}</div>
    `;
    provenanceDiv.appendChild(newItem);
  }
}

// Async map rendering function - runs in background
async function renderMapAsync(attributes) {
  try {
    // Add loading indicator for map
    const googleMapElement = document.getElementById('googleMap');
    if(googleMapElement) {
      googleMapElement.innerHTML = '<div class="map-loading">Loading map...</div>';
    }

    // Map functionality using Aura data
    const createCoords = async (address, key) => {
      const geocoder = new google.maps.Geocoder();

      try {

        // Check if markerInfo exists for this key, if not provide fallback
        let markerConfig;
        if (markerInfo && markerInfo[key]) {
          markerConfig = markerInfo[key];

        } else {
          // Generate fallback config based on key name
          const fallbackLabel = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()).replace(/Location$/, '');
          const fallbackColor = '#808080'; // Default gray color
          markerConfig = {
            label: fallbackLabel,
            color: fallbackColor
          };
        }

        const coords = await geocoder.geocode({address:address});

        const lat = coords?.results[0]?.geometry?.location.lat() || null
        const lng = coords?.results[0]?.geometry?.location.lng() || null


        const markerData = {
          name: address,
          color: markerConfig.color,
          label: markerConfig.label,
          position: {
            lat,
            lng,
          },
        }
        return markerData
      } catch (err) {
        console.error('Geocoding error for', address, ':', err);
        return false
      }
    }

    const getStateLocation = async (filteredLocations) => {
      const combinedLocations = Object.entries(filteredLocations)
          .filter((l) => !!l[1])
          .map((location) => createCoords(location[1], location[0]))

      const locationsData = await Promise.allSettled(combinedLocations)
      const locations = locationsData.filter((l) => !!l).filter((l) => !!l.value)
      console.log(locations)

      return locations;
    }

    // Build locations from Aura data
    let customFieldLocations = {}

    // Add factory location if available
    if(attributes.factory && attributes.factory.address) {
      const factoryAddress = attributes.factory.address;
      customFieldLocations.factoryLocation = `${factoryAddress.city}, ${factoryAddress.country}`;
    }

    // Add distribution center location if available
    if(attributes.dc && attributes.dc['address.city'] && attributes.dc['address.country']) {
      customFieldLocations.dcLocation = `${attributes.dc['address.city']}, ${attributes.dc['address.country']}`;
    }

    // Add material manufacturer location if available
    if(attributes.primaryArticle && attributes.primaryArticle.materialMfgLocation) {
      customFieldLocations.materialMfgLocation = attributes.primaryArticle.materialMfgLocation;
    }

    // Add material spinner location if available
    if(attributes.primaryArticle && attributes.primaryArticle.materialSpinnerLocation) {
      customFieldLocations.materialSpinnerLocation = attributes.primaryArticle.materialSpinnerLocation;
    }

    // Add component A source location if available
    if(attributes.primaryArticle && attributes.primaryArticle.componentASourceLocation) {
      customFieldLocations.componentASourceLocation = attributes.primaryArticle.componentASourceLocation;

    }

    // Add component B source location if available
    if(attributes.primaryArticle && attributes.primaryArticle.componentBSourceLocation) {
      customFieldLocations.componentBSourceLocation = attributes.primaryArticle.componentBSourceLocation;
    }

    // Add component C source location if available
    if(attributes.primaryArticle && attributes.primaryArticle.componentCSourceLocation) {
      customFieldLocations.componentCSourceLocation = attributes.primaryArticle.componentCSourceLocation;
    }

    // Add any other location data from attributes if available
    // You can add more location mappings here based on your data structure


    let markers = await getStateLocation(customFieldLocations)

    var options = {
      zoom:2,
      center:{ lat: 37.09024,
        lng: -95.712891},
      fullscreenControl: false,
      streetViewControl: false,
      mapTypeControl: false,
      styles
    }

    var map = new google.maps.Map(document.getElementById('googleMap'),options);

    for(let marker of markers) {
      const markerImage = {
        fillOpacity: 1,
        path: 'M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0',
        fillColor: marker.value.color,
        strokeWeight: 1,
        strokeColor: 'black',
        scale: 0.1,
      }

      new google.maps.Marker({
        position:{
          lat: marker.value.position.lat,
          lng: marker.value.position.lng,
        },
        map: map,
        icon: markerImage
      });

      let markerInfo = `<svg
              width="12"
              height="13"
              viewBox="0 0 12 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="6"
                cy="6.70312"
                r="5.75"
                fill="white"
                stroke="black"
                strokeWidth="0.5"
              />
              <circle cx="6" cy="6.70312" r="4" fill=`+marker.value.color+` />
            </svg> <span>`+marker.value.label+`</span>`

      const mapMarkersElement = document.querySelector('.cProd__map-markers');
      if(mapMarkersElement) {
        const markerDiv = document.createElement('div');
        markerDiv.className = 'cProd__map-markers-item';
        markerDiv.innerHTML = markerInfo;
        mapMarkersElement.appendChild(markerDiv);
      }

    }

    const bounds = new google.maps.LatLngBounds()

    markers.map((item) => {
      bounds.extend(item.value.position)
      return item.id
    })

    map.fitBounds(bounds)

    console.log('Map rendering completed');

  } catch (err) {
    console.error('Map rendering error:', err);
    // Show error message in map container
    const googleMapElement = document.getElementById('googleMap');
    if(googleMapElement) {
      googleMapElement.innerHTML = '<div class="map-error">Map could not be loaded</div>';
    }
  }
}

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function(){
  const anchorSelector = 'a[href^="#"]';
  const anchorElements = document.querySelectorAll(anchorSelector);

  anchorElements.forEach(function(anchor) {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.getAttribute('href');
      const destination = document.querySelector(targetId);

      if (destination) {
        const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-bottom-position-desktop');
        const scrollPosition = destination.offsetTop - parseFloat(headerHeight);

        // Smooth scroll animation using vanilla JavaScript
        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth'
        });
      }
    });
  });

  // Initialize claim ownership functionality
  initializeClaimOwnership();
});

/***************************************************************
 * Connected Products Page - Ownership Claim Logic
 * Author: David / Linea Codice
 ***************************************************************/

console.log("[AT] Claim ownership module loaded");

/* ---------------------------
   Extract uniqueHash from URL
----------------------------*/
function getUniqueHashFromUrl() {
  const params = new URLSearchParams(window.location.search);
  return params.get("id");
}

/* ---------------------------
   Shopify customer login check
----------------------------*/
function getCurrentCustomer() {
  return window.__AT_CUSTOMER || null;
}

function isLoggedIn() {
  const customer = getCurrentCustomer();
  console.log("[AT] Current customer:", customer);
  return !!(customer && customer.email && customer.id);
}

/* ---------------------------
   CLAIM OWNERSHIP request
----------------------------*/
let isClaimInProgress = false;

async function claimOwnership() {
  // Prevent multiple simultaneous claims
  if (isClaimInProgress) {
    console.log("[AT] Claim already in progress, ignoring click");
    return;
  }

  const uniqueHash = getUniqueHashFromUrl();
  if (!uniqueHash) {
    console.error("[AT] No unique hash in URL");
    updateClaimButtonText("Error: No product ID found in URL");
    return;
  }

  const customer = getCurrentCustomer();
  if (!customer || !customer.email) {
    console.error("[AT] User not logged in");
    updateClaimButtonText("Error: User not logged in");
    return;
  }


  const payload = {
    externalProductId: productId,
    uniqueHash: uniqueHash,
    externalUserId: String(customer.id)
  };

  console.log("[AT] Claiming ownership with payload:", payload);

  const btn = document.getElementById("claim-ownership-btn");

  // Mark claim as in progress and disable link
  isClaimInProgress = true;
  if (btn) {
    btn.style.pointerEvents = "none";
    btn.style.opacity = "0.6";
    btn.style.color = "#0c61eb";
  }

  updateClaimButtonText("Aura Blockchain Registration in Progress...");

  try {
    // Use the same base URL as the existing code
    console.log('Fetching data from:', 'claim');
    const res = await fetch(`${baseBackendUrl}/dpp/claim`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },

      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      const errorData = await res.json().catch(() => ({ error: "Unknown error" }));
      throw new Error(errorData.error || `Claim request failed: ${res.status}`);
    }

    console.log("[AT] Claim success:");

    // Keep button disabled permanently after success
    if (btn) {
      btn.style.opacity = "0.5";
      btn.style.color = "#0a0a0a";
      btn.style.cursor = "not-allowed";
    }
    updateClaimButtonText("Ownership claimed successfully !");

  } catch (err) {
    console.error("[AT] Error during claim", err);

    // Re-enable button on error
    isClaimInProgress = false;
    if (btn) {
      btn.style.pointerEvents = "auto";
      btn.style.opacity = "1";
      btn.style.color = "#0a0a0a";
    }
    updateClaimButtonText(`Error: ${err.message}`);
  }
}

/* ---------------------------
   Update claim button text
----------------------------*/
function updateClaimButtonText(message) {
  const btn2 = document.getElementById("claim-ownership-btn");
  if (!btn2) return;

  const h3 = btn2.querySelector('h3');
  if (h3) {
    const svg = h3.querySelector('svg');
    const svgHTML = svg ? svg.outerHTML : '';
    h3.innerHTML = message + ' ' + svgHTML;
  }
}

/* ---------------------------
   Handle Claim Button Click
----------------------------*/
function setupClaimButton() {
  const btn = document.getElementById("claim-ownership-btn");
  if (!btn) {
    console.log("[AT] Claim button not found");
    return;
  }

  btn.addEventListener("click", (e) => {
    e.preventDefault();
    if (!isLoggedIn()) {
      console.log("[AT] User not logged in, redirecting to login");

      // Preserve intent (we want to claim after login)
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('claim', 'true');
      const returnUrl = currentUrl.pathname + currentUrl.search;

      // Store intent for register flow
      localStorage.setItem("AT_claim_intent", returnUrl);

      // CHECK: Are you using Classic Accounts (email/pass) or New Accounts (code)?

      // OPTION A: Classic Customer Accounts (Legacy)
      // Use this if you switched to "Classic customer accounts" in Shopify Admin > Settings > Customer accounts
      // window.location.href = `/account/login?return_url=${encodeURIComponent(returnUrl)}`;

      // OPTION B: New Customer Accounts (6-digit code)
      // Use this if you are using the new system
      window.location.href = `/customer_authentication/login?return_to=${encodeURIComponent(returnUrl)}`;

      return;
    }

    // Already logged in → initiate KYC verification
    console.log("[AT] User logged in, starting KYC verification");
    handleKYCVerification();
  });
}

/* ---------------------------
   Auto claim after login
----------------------------*/
function initializeClaimOwnership() {
  setupClaimButton();

  // If user returns from login with #claim
  const params = new URLSearchParams(location.search);
  if (params.has("claim") && isLoggedIn()) {
    console.log("[AT] Auto-claim triggered after login");

    // Clean URL
    params.delete("claim");
    const cleanUrl = window.location.pathname + "?" + params.toString();
    window.history.replaceState({}, "", cleanUrl);

    // Small delay to ensure page is fully loaded
    setTimeout(() => {
      handleKYCVerification();
    }, 1500);
  }
}

/* ---------------------------
   Handle Claim Button State
----------------------------*/
async function handleClaimButtonState(status, productId, uniqueHash) {
  const btn = document.getElementById("claim-ownership-btn");
  if (!btn) return;

  // Case 1: Product is NOT claimed (CREATED)
  if (status === 'CREATED') {
    console.log("[AT] Product is unclaimed. Enabling claim button.");
    // Default behavior is already correct (button enabled)
    // Just ensure text is correct
    const h3 = btn.querySelector('h3');
    if(h3) h3.innerHTML = 'Register your ownership of this product ' + (h3.querySelector('svg')?.outerHTML || '');
    return;
  }

  // Case 2: Product is ALREADY claimed (OWNED)
  if (status === 'OWNED') {
    console.log("[AT] Product is already claimed.");

    // Disable button immediately
    btn.classList.add('disabled');
    btn.style.pointerEvents = 'none';
    btn.style.opacity = '0.6';
    btn.removeAttribute('href');

    const h3 = btn.querySelector('h3');
    // Default message while checking
    if(h3) h3.innerHTML = 'Product already registered ' + (h3.querySelector('svg')?.outerHTML || '');

    // Hide "Sign-in required" text if present
    const subText = btn.querySelector('.cProd__buttons-holder_sub_text');
    if(subText) subText.style.display = 'none';

    // Check if current user is the owner
    if (isLoggedIn()) {
      const customer = getCurrentCustomer();
      console.log("[AT] Checking if current user is the owner...");

      try {
        const isOwner = await checkOwnership(customer.email, uniqueHash, productId);

        if (isOwner) {
          if(h3) h3.innerHTML = 'You own this product ' + (h3.querySelector('svg')?.outerHTML || '');
          console.log("[AT] User IS the owner.");
        } else {
          if(h3) h3.innerHTML = 'This product is owned by an AnotherTomorrow customer ' + (h3.querySelector('svg')?.outerHTML || '');
          console.log("[AT] User is NOT the owner.");
        }
      } catch (err) {
        console.error("[AT] Error checking ownership:", err);
      }
    } else {
      // Not logged in, but product is owned
      if(h3) h3.innerHTML = 'This product is owned by an AnotherTomorrow customer ' + (h3.querySelector('svg')?.outerHTML || '');
    }
  }
}

/* ---------------------------
   Check Ownership API Call
----------------------------*/
async function checkOwnership(email, uniqueHash, productId) {
  try {
    console.log('Fetching data from:', 'check');
    const res = await fetch(`${baseBackendUrl}/check-ownership`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email, uniqueHash, productId })
    });

    if (!res.ok) {
      throw new Error(`Ownership check failed: ${res.status}`);
    }

    const data = await res.json();
    return data.isOwner;
  } catch (err) {
    console.error("[AT] Check ownership error", err);
    return false;
  }
}

/***************************************************************
 * KYC Verification Functions
 * Handles identity verification via Veriff before claim
 ***************************************************************/

/* ---------------------------
   Get User Profile (KYC Status)
----------------------------*/
async function getUserProfile(userId) {
  try {
    console.log('[AT-KYC] 📡 Fetching profile for userId:', userId);
    console.log('[AT-KYC] 🌐 URL:', `${baseBackendUrl}/user/profile/${userId}`);

    console.log('Fetching data from:', 'profile');
    const response = await fetch(`${baseBackendUrl}/user/profile/${userId}`);

    console.log('[AT-KYC] 📊 Response status:', response.status);

    // User not found (404 or 500 NotFoundException)
    if (response.status === 404 || response.status === 500) {
      console.log('[AT-KYC] ❌ User not found (status:', response.status + ')');
      return null;
    }

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const profile = await response.json();
    console.log('[AT-KYC] 📦 Profile received:', JSON.stringify(profile, null, 2));
    console.log('[AT-KYC] 🔍 isVerified:', profile?.isVerified, '(type:', typeof profile?.isVerified + ')');
    console.log('[AT-KYC] 🔍 status:', profile?.status);
    console.log('[AT-KYC] 🔍 veriffId:', profile?.veriffId);

    return profile;

  } catch (error) {
    console.error('[AT-KYC] ❌ Error getting user profile:', error);
    throw error;
  }
}

/* ---------------------------
   Create User
----------------------------*/
async function createUser(externalUserId, email) {
  try {
    console.log('[AT-KYC] 📝 Creating user:', { externalUserId, email });

    console.log('Fetching data from:', 'create');
    const response = await fetch(
        `${baseBackendUrl}/user/create`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            externalUserId: String(externalUserId),  // Convert to string
            email: email
          })
        }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `Failed to create user: ${response.status}`);
    }

    const user = await response.json();
    console.log('[AT-KYC] ✅ User created:', user);

    return user;

  } catch (error) {
    console.error('[AT-KYC] ❌ Error creating user:', error);
    throw error;
  }
}

/* ---------------------------
   Create Veriff Session
----------------------------*/
async function createVeriffSession(userId, email) {
  try {
    console.log('[AT-KYC] Creating Veriff session for:', userId);

    console.log('Fetching data from:', 'identity');
    const response = await fetch(
        `${baseBackendUrl}/identity/create-session`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            externalUserId: String(userId),
            email: email
          })
        }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `API error: ${response.status}`);
    }

    const veriffUrl = await response.text();
    console.log('[AT-KYC] Veriff URL created');

    return veriffUrl;

  } catch (error) {
    console.error('[AT-KYC] Error creating Veriff session:', error);
    throw error;
  }
}

/* ---------------------------
   Poll User Verification Status
----------------------------*/
async function pollUserVerification(userId, maxDuration = KYC_POLLING_MAX_DURATION) {
  const startTime = Date.now();
  let attemptCount = 0;
  const maxAttempts = Math.floor(maxDuration / KYC_POLLING_INTERVAL);

  console.log(`[AT-KYC-POLL] 🚀 Starting polling for userId=${userId}`);
  console.log(`[AT-KYC-POLL] ⏱️ Max duration: ${maxDuration/1000}s (${maxAttempts} attempts)`);

  while (Date.now() - startTime < maxDuration) {
    attemptCount++;
    const elapsed = Math.floor((Date.now() - startTime) / 1000);

    try {
      console.log(`[AT-KYC-POLL] 📡 Attempt ${attemptCount}/${maxAttempts} (${elapsed}s elapsed)`);

      const profile = await getUserProfile(userId);

      // Success case: User is verified!
      if (profile.isVerified === true) {
        console.log('[AT-KYC-POLL] ✅ SUCCESS! User is verified');
        return { status: 'success', profile };
      }

      // Check if verification failed
      if (profile.status === 'declined') {
        console.log('[AT-KYC-POLL] ❌ DECLINED');
        return { status: 'declined', profile };
      }

      // Check if verification expired/abandoned
      if (profile.status === 'expired' || profile.status === 'abandoned') {
        console.log('[AT-KYC-POLL] ⚠️ EXPIRED/ABANDONED');
        return { status: 'expired', profile };
      }

      // Still pending, wait before next poll
      console.log(`[AT-KYC-POLL] ⏳ Still pending (status: ${profile.status || 'unknown'})`);

    } catch (error) {
      console.error('[AT-KYC-POLL] ❌ ERROR during polling:', error);
      console.error('[AT-KYC-POLL] Error details:', {
        message: error.message,
        attemptCount,
        elapsed
      });
      // Continue polling even if one request fails
    }

    console.log(`[AT-KYC-POLL] 💤 Waiting ${KYC_POLLING_INTERVAL/1000}s before next attempt...`);
    await new Promise(resolve => setTimeout(resolve, KYC_POLLING_INTERVAL));
  }

  // Timeout reached
  console.log('[AT-KYC-POLL] ⏱️ TIMEOUT reached after', maxDuration/1000, 'seconds');
  return { status: 'timeout' };
}

/* ---------------------------
   Handle Pending Verification
----------------------------*/
function handlePendingVerification(status) {
  console.log('[AT-KYC] Handling pending verification:', status);

  let message = '';
  let buttonText = 'Close';
  let buttonAction = () => window.ATPopup.close();

  switch(status) {
    case 'created':
    case 'submitted':
    case 'review':
      message = `
        <p><strong>Verification in progress</strong></p>
        <p>Your identity verification is currently being reviewed.</p>
        <p>Status: <span style="text-transform: capitalize;">${status}</span></p>
        <p>This usually takes a few minutes. Please try claiming again shortly.</p>
      `;
      break;

    case 'declined':
      message = `
        <p><strong>Verification declined</strong></p>
        <p>Your verification ended in error, please contact the AT Support Team</p>
      `;
      buttonText = 'Contact Support';
      buttonAction = () => {
        window.location.href = '/pages/contact';
      };
      break;

    case 'resubmission_requested':
      message = `
        <p><strong>Additional information required</strong></p>
        <p>We need more information to verify your identity.</p>
        <p>Please contact the AT Support Team for assistance.</p>
      `;
      buttonText = 'Contact Support';
      buttonAction = () => {
        window.location.href = '/pages/contact';
      };
      break;

    default:
      message = `<p>Verification status: ${status}. Please contact support if this persists.</p>`;
  }

  window.ATPopup.open({
    title: 'Verification Status',
    content: message
  });
  window.ATPopup.setButton(buttonText, buttonAction);
}

/* ---------------------------
   Start KYC Flow
----------------------------*/
async function startKYCFlow(userId, email) {
  console.log('[AT-KYC] Starting KYC flow for user:', userId);

  // Step 1: Open popup with explanation
  window.ATPopup.open({
    title: 'Identity Verification Required',
    content: `
      <p>At Another Tomorrow we take authenticity and trust seriously. As a result, the first time you claim ownership of a product, we'll ask you to verify your identity in a quick, seamless way that allows us to validate your account.</p>
      <p>Once set up, we won't ask you for this again for future product claims.</p>
    `
  });

  // Step 2: Create Veriff session
  window.ATPopup.showLoader('Preparing verification...');

  try {
    const veriffUrl = await createVeriffSession(userId, email);

    // Step 3: Show button to open Veriff
    window.ATPopup.hideLoader();
    window.ATPopup.setButton('Verify my identity', async () => {
      // Open Veriff in new tab
      window.open(veriffUrl, '_blank');

      // Update popup
      window.ATPopup.updateContent(`
        <p><strong>Verification window opened</strong></p>
        <p>Please complete the verification process in the new window.</p>
        <p>We'll automatically detect when you're done - this may take a few moments.</p>
      `);
      window.ATPopup.hideButton();

      // Start polling
      window.ATPopup.showLoader('Waiting for verification completion...');

      const result = await pollUserVerification(userId);

      window.ATPopup.hideLoader();

      // Handle polling result
      if (result.status === 'success') {
        window.ATPopup.showSuccess('Verification complete!');

        setTimeout(() => {
          window.ATPopup.close();
          // Auto-trigger claim
          claimOwnership();
        }, 1500);

      } else if (result.status === 'declined') {
        window.ATPopup.showError('Your verification was declined. Please contact support.');
        window.ATPopup.setButton('Contact Support', () => {
          window.location.href = '/pages/contact';
        });

      } else if (result.status === 'expired') {
        window.ATPopup.showError('Verification session expired. Please try again.');
        window.ATPopup.setButton('Retry', () => {
          window.ATPopup.close();
        });

      } else {
        // Timeout
        window.ATPopup.updateContent(`
          <p><strong>Still processing...</strong></p>
          <p>Your verification is taking longer than expected.</p>
          <p>Please wait a few more minutes and try claiming again.</p>
        `);
        window.ATPopup.setButton('Close', () => {
          window.ATPopup.close();
        });
      }
    });

  } catch (error) {
    window.ATPopup.hideLoader();

    if (error.message.includes('already verified')) {
      window.ATPopup.showSuccess('You are already verified!');
      setTimeout(() => {
        window.ATPopup.close();
        claimOwnership();
      }, 1500);

    } else if (error.message.includes('verification in progress')) {
      window.ATPopup.showError('A verification is already in progress.');

    } else {
      window.ATPopup.showError(`Error: ${error.message}`);
    }
  }
}

/* ---------------------------
   Main KYC Verification Handler
----------------------------*/
async function handleKYCVerification() {
  const customer = getCurrentCustomer();

  if (!customer || !customer.id || !customer.email) {
    console.error('[AT-KYC] Customer data incomplete');
    updateClaimButtonText('Error: User information incomplete');
    return;
  }

  console.log('[AT-KYC] Starting KYC verification for customer:', customer.id);

  try {
    // Step 1: Check current verification status
    const profile = await getUserProfile(customer.id);

    // Case New User: Profile not found → Create user then start verification
    if (!profile) {
      console.log('[AT-KYC] 🆕 New user detected, creating user first');

      try {
        await createUser(customer.id, customer.email);
        console.log('[AT-KYC] ✅ User created, starting verification flow');
      } catch (createError) {
        console.error('[AT-KYC] ❌ Failed to create user:', createError);
        updateClaimButtonText('Error: Failed to create user account');
        return;
      }

      await startKYCFlow(customer.id, customer.email);
      return;
    }

    // Case A: User already verified → direct claim
    if (profile.isVerified) {
      console.log('[AT-KYC] User already verified, proceeding to claim');
      await claimOwnership();
      return;
    }

    // Case B: Verification in progress
    if (profile.status && profile.status !== 'expired' && profile.status !== 'abandoned') {
      handlePendingVerification(profile.status);
      return;
    }

    // Case C: Need to start new verification
    await startKYCFlow(customer.id, customer.email);

  } catch (error) {
    console.error('[AT-KYC] Error in KYC verification:', error);
    updateClaimButtonText(`Error: ${error.message}`);
  }
}